var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotulFullHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61px",
    height: "17px",
    viewBox: "0 0 61 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo / Partner / motul-full_horizontal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Prizes-",
    transform: "translate(-243.000000, -276.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-/-Partner-/-motul-full_horizontal",
    transform: "translate(243.000000, 276.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_motul_cmyk"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#D8232A",
    points: "0.0150617284 16.9391045 60.9005926 16.9391045 60.9005926 0.118238806 0.0150617284 0.118238806"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-2",
    fill: "#FFFFFF",
    points: "17.1003333 2.91968657 17.1003333 14.1396866 13.2302222 14.1396866 13.4440988 9.2439403 11.3394733 14.1396866 8.75914815 14.1396866 8.02212757 9.17162687 6.77376132 14.129791 2.80173251 14.129791 6.04853909 2.91968657 10.257037 2.91968657 10.9119712 7.47720896 12.7909218 2.91968657 17.1003333 2.91968657"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-3",
    fill: "#FFFFFF",
    points: "38.7716502 6.47649254 37.0347819 6.40468657 36.1441317 14.129791 31.9333745 14.129791 32.8915514 6.42016418 31.2919959 6.47649254 28.6054856 2.91486567 39.1394074 2.91486567 38.7716502 6.47649254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.14693,2.91486567 L43.361963,9.8810597 C43.3378642,10.302 43.5268889,10.7226866 43.8969053,10.9020746 C44.2782181,11.046194 44.7534156,10.9878358 45.0506337,10.6983284 C45.3114527,10.4689552 45.4075967,10.1581343 45.4793909,9.83259701 L46.4164815,2.91486567 L50.4374609,2.91486567 L49.5696543,10.5887164 C49.3788724,11.6830597 48.878823,12.7177761 47.9163786,13.4155373 C46.5241728,14.4355373 44.669321,14.5915821 42.8734609,14.3403881 C41.4473663,14.0752388 39.8184403,13.1369403 39.353786,11.6706269 C39.1527119,11.1423582 39.1876049,10.5065075 39.1876049,9.92926866 L40.0205185,2.91486567 L44.14693,2.91486567",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-5",
    fill: "#FFFFFF",
    points: "54.812893 10.5838955 58.1179383 10.5838955 57.1439465 14.129791 50.1033416 14.129791 51.5668395 2.91486567 55.7504856 2.91486567 54.812893 10.5838955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.249679,3.33073134 L27.6663868,3.65550746 L30.1274733,6.85277612 C30.4015967,7.39246269 30.412893,8.07880597 30.3887942,8.72886567 C30.3539012,10.8777164 28.9629506,12.8847313 27.0235021,13.7862388 C24.6575556,14.9171194 21.4940905,14.3878358 19.6397407,12.5373731 C17.9987654,10.9619552 17.6653992,8.30614925 18.5219095,6.26335821 C19.5207531,3.99144776 21.8746502,2.57258209 24.3008436,2.68219403 C25.3473827,2.70528358 26.3577737,2.88568657 27.249679,3.33073134 Z M24.705251,6.40773134 C23.8133457,6.28619403 22.9688848,6.70713433 22.517284,7.51273134 C22.1369753,8.18638806 22.0413333,9.12291045 22.4454897,9.80874627 C22.7311605,10.3847164 23.3260988,10.7820597 23.9561811,10.8419403 C24.7760412,10.914 25.5020165,10.5065075 25.9300206,9.80874627 C26.369823,9.16020896 26.3946749,8.10113433 26.0364568,7.40514925 C25.7989835,6.8761194 25.2396914,6.50389552 24.705251,6.40773134 L24.705251,6.40773134 Z",
    id: "Fill-6",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotulFullHorizontal);
export default __webpack_public_path__ + "static/media/motul-full_horizontal.74960ddfc3117fa59546bcc862e5b824.svg";
export { ForwardRef as ReactComponent };